// Contact action types
export const SEND_CONTACT_MESSAGE_REQUEST = 'SEND_CONTACT_MESSAGE_REQUEST';
export const SEND_CONTACT_MESSAGE_SUCCESS = 'SEND_CONTACT_MESSAGE_SUCCESS';
export const SEND_CONTACT_MESSAGE_FAILURE = 'SEND_CONTACT_MESSAGE_FAILURE';

export const FETCH_CONTACT_MESSAGES_REQUEST = 'FETCH_CONTACT_MESSAGES_REQUEST';
export const FETCH_CONTACT_MESSAGES_SUCCESS = 'FETCH_CONTACT_MESSAGES_SUCCESS';
export const FETCH_CONTACT_MESSAGES_FAILURE = 'FETCH_CONTACT_MESSAGES_FAILURE';

export const FETCH_CONTACT_MESSAGE_REQUEST = 'FETCH_CONTACT_MESSAGE_REQUEST';
export const FETCH_CONTACT_MESSAGE_SUCCESS = 'FETCH_CONTACT_MESSAGE_SUCCESS';
export const FETCH_CONTACT_MESSAGE_FAILURE = 'FETCH_CONTACT_MESSAGE_FAILURE';

export const MARK_MESSAGE_AS_READ_REQUEST = 'MARK_MESSAGE_AS_READ_REQUEST';
export const MARK_MESSAGE_AS_READ_SUCCESS = 'MARK_MESSAGE_AS_READ_SUCCESS';
export const MARK_MESSAGE_AS_READ_FAILURE = 'MARK_MESSAGE_AS_READ_FAILURE';

export const MARK_MESSAGE_AS_REPLIED_REQUEST = 'MARK_MESSAGE_AS_REPLIED_REQUEST';
export const MARK_MESSAGE_AS_REPLIED_SUCCESS = 'MARK_MESSAGE_AS_REPLIED_SUCCESS';
export const MARK_MESSAGE_AS_REPLIED_FAILURE = 'MARK_MESSAGE_AS_REPLIED_FAILURE';

export const DELETE_CONTACT_MESSAGE_REQUEST = 'DELETE_CONTACT_MESSAGE_REQUEST';
export const DELETE_CONTACT_MESSAGE_SUCCESS = 'DELETE_CONTACT_MESSAGE_SUCCESS';
export const DELETE_CONTACT_MESSAGE_FAILURE = 'DELETE_CONTACT_MESSAGE_FAILURE';

export const FETCH_UNREAD_COUNT_REQUEST = 'FETCH_UNREAD_COUNT_REQUEST';
export const FETCH_UNREAD_COUNT_SUCCESS = 'FETCH_UNREAD_COUNT_SUCCESS';
export const FETCH_UNREAD_COUNT_FAILURE = 'FETCH_UNREAD_COUNT_FAILURE';


